"use strict";

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

var _cartDrawer = require("./cart-drawer");

var _cartDrawer2 = _interopRequireDefault(_cartDrawer);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

// quick add
(0, _jquery2.default)(document).on("click", ".js-quick-add", function (e) {
  e.preventDefault();
  var scrollTop = 0;
  var $this = (0, _jquery2.default)(this);
  var vid = $this.parents(".js-product-item").find(".current-price-variant").data("vid-price");

  if ((0, _jquery2.default)("body").attr("id") === "your-shopping-cart") {
    _jquery2.default.ajax({
      url: "/cart/add.js",
      type: "POST",
      data: {
        id: vid,
        quantity: 1
      },
      dataType: "json",
      beforeSend: function beforeSend() {
        (0, _jquery2.default)(".section-cart").addClass("loading-icon");
      }
    }).done(function () {
      (0, _cartDrawer.populateNormalCart)();
    }).fail(function () {
      (0, _jquery2.default)(".section-cart").removeClass("loading-icon");
      console.log("error cart remove");
    });
  } else {
    _jquery2.default.ajax({
      url: "/cart/add.js",
      type: "POST",
      data: {
        id: vid,
        quantity: 1
      },
      dataType: "json"
    }).done(function () {
      (0, _cartDrawer2.default)(true);
      (0, _jquery2.default)(".cart-drawer, body").addClass("expanded");

      if ((0, _jquery2.default)(".cart-drawer").hasClass("expanded") && (0, _jquery2.default)(".top-bar--absolute").length) {
        (0, _jquery2.default)(".top-bar--absolute").addClass("display-top-bar-absolute");
        scrollTop = (0, _jquery2.default)(window).scrollTop();
        (0, _jquery2.default)("body").attr("data-top", (0, _jquery2.default)(window).scrollTop()).css("top", -scrollTop);
        (0, _jquery2.default)("html").addClass("no-scroll");
      } else {
        (0, _jquery2.default)(".top-bar--absolute").removeClass("display-top-bar-absolute");
        (0, _jquery2.default)("html").removeClass("no-scroll");
        (0, _jquery2.default)("html,body").animate({
          scrollTop: Number((0, _jquery2.default)("body").data("top"))
        }, 0);
      }

      setTimeout(function () {
        (0, _jquery2.default)(".cart-drawer").removeClass("expanded");
      }, 1500);
    }).fail(function () {
      console.log("error quick add");
    });
  }
});